module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/last-lock-192a1a.svg";